import IExportFormat from "../interfaces/IExportFormat";
import IExportOptions from "../interfaces/IExportOptions";
import ISource from "../interfaces/ISource";
import ISourceType from "../interfaces/ISourceType";
import IUsability from "../interfaces/IUsability";

interface IRefElement {
    _id: string,
    author: string,
    created: Date,
    refType: ISourceType,
    summary: string,
    title: string,
    year: number,
}

export function exportJSON(sources: ISource[], exportOption: IExportOptions, exportFormat: IExportFormat) {
    let exportableSources: ISource[] = [];

    switch (exportOption) {
        case IExportOptions.OnlyAccepted: {
            exportableSources = sources.filter((source: ISource) => source.usability === IUsability.Accepted);
            break;
        }

        case IExportOptions.AcceptedAndTentative: {
            exportableSources = sources.filter((source: ISource) =>
                source.usability === IUsability.Accepted || source.usability === IUsability.Tentative);
            break;
        }

        case IExportOptions.All: {
            exportableSources = sources;
            break;
        }

        default: {
            exportableSources = sources;
            break;
        }
    }

    switch (exportFormat) {
        case IExportFormat.Literature_Wizard: {
            return exportRawJSON(exportableSources);
        }

        case IExportFormat.SWOFI: {
            return exportRefToolJSON(exportableSources);
        }

        default: {
            return exportRawJSON(exportableSources);
        }
    }
}

function exportRawJSON(sources: ISource[]) {
    const finalObject: { references: ISource[] } = {
        references: sources,
    };

    return finalObject;
}

function exportRefToolJSON(sources: ISource[]) {
    const finalObject: { outline: any[], references: IRefElement[] } = {
        outline: [],
        references: []
    };

    for (const source of sources) {
        const refElement: IRefElement = {
            ...source,
            _id: source._id || source.old_id || "",
            author: source.authors.toString(),
            created: new Date(),
            refType: source.type,
            summary: source.comment || "",
        };

        finalObject.references.push(refElement);
    }

    return finalObject;
}



// WEBPACK FOOTER //
// ./src/utils/exportJSON.ts